class Emitter {
  constructor() {
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
    return () => {
      this.off(event, listener);
    };
  }
  off(event, listener) {
    if (!this.events[event]) {
      return;
    }
    const idx = this.events[event].indexOf(listener);
    if (idx > -1) {
      this.events[event].splice(idx, 1);
    }
  }
  clear() {
    Object.keys(this.events).forEach(event => {
      const key = event;
      this.events[key].splice(0, this.events[key].length);
    });
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (!this.events[event]) {
      return;
    }
    [...this.events[event]].forEach(listener => listener.apply(this, args));
  }
  once(event, listener) {
    var _this = this;
    const remove = this.on(event, function () {
      remove();
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      listener.apply(_this, args);
    });
  }
}

export { Emitter };
//# sourceMappingURL=emitter.js.map
